export const AccordionButton = ({
  isOpen = false,
  handleDropdown,
}: {
  isOpen: boolean;
  handleDropdown(): void;
}) => {
  return (
    <span
      className={`material-icons text-xl cursor-pointer`}
      onClick={handleDropdown}
    >
      {`expand_${isOpen ? 'less' : 'more'}`}
    </span>
  );
};
